module.exports = __webpack_public_path__ + "img/l_r_vid_2_splash.22e9f9f4.jpg";